import { createApp } from "vue"
import { createRouter, createWebHistory } from 'vue-router';
import { useHead } from '@vueuse/head';

import HomePage from "./pages/HomePage.vue";
import WhatsNew from "./pages/WhatsNew.vue";
import AboutPage from "./pages/AboutPage.vue";
import GetInvolved from "./pages/GetInvolved.vue";
import CreditsPage from "./pages/CreditsPage.vue";
import ImportantInformation from "./pages/ImportantInformation.vue";
import SearchResults from "./pages/SearchResults.vue";
import ExplorePage from "./pages/ExplorePage.vue";
import ErrorPage from "./pages/ErrorPage.vue";

// Vue.use(Router);
// Vue.use(Meta, {
//   keyName: "metaInfo",
//   refreshOnceOnNavigation: true,
// });

function assignParams(to) {
  let array = Object.values(to.params);
  to.params.theme = null;
  to.params.country = null;
  to.params.filter = null;
  to.params.territory = null;
  to.params.itinerary = null;
  to.params.subItinerary = null;
  to.params.location = null;
  to.params.route = null;
  to.params.monument = null;
  to.params.language = null;
  for (let i = 0; i < array.length; i++) {
    if (!array[i]) {
      continue;
    }
    if (array[i].includes("t-")) {
      to.params.theme = array[i];
    } else if (array[i].includes("c-")) {
      to.params.country = array[i];
    } else if (array[i].includes("f-")) {
      to.params.filter = array[i];
    } else if (array[i].includes("tr-")) {
      to.params.territory = array[i];
      // Put "si-" in front of "i" for priority
    } else if (array[i].includes("si-")) {
      to.params.subItinerary = array[i];
    } else if (array[i].includes("i-")) {
      to.params.itinerary = array[i];
    } else if (array[i].includes("l-")) {
      to.params.location = array[i];
    } else if (array[i].includes("r-")) {
      to.params.route = array[i];
    } else if (array[i].includes("m-")) {
      to.params.monument = array[i];
    } else if (array[i].includes("lan-")) {
      to.params.language = array[i];
    } else if (array[i].includes("tab-")) {
      to.params.tab = array[i];
    }
  }
}

const routes = [
  {
    path: "/",
    name: "home",
    components: {
      default: HomePage,
    },
  },
  {
    path: "/new",
    name: "whats-new",
    components: {
      default: WhatsNew,
    },
  },
  {
    path: "/about",
    name: "about",
    components: {
      default: AboutPage,
    },
  },
  {
    path: "/get-involved",
    name: "get-involved",
    components: {
      default: GetInvolved,
    },
  },
  {
    path: "/credits",
    name: "credits",
    components: {
      default: CreditsPage,
    },
  },
  {
    path: "/important-information",
    name: "important-information",
    components: {
      default: ImportantInformation,
    },
  },
  {
    path: "/search/:type",
    name: "search",
    components: {
      default: SearchResults,
    },
  },
  {
    path: "/themes/:theme/:country?/:territory?/:location?/:monument?/:language?/:tab?",
    name: "themes",
    components: {
      default: ExplorePage,
    },
    beforeEnter: (to, from, next) => {
      assignParams(to);
      if (from.params.theme !== to.params.theme) {
        let theme = to.params.theme.substring(2);
        let url = `${process.env.VUE_APP_API_ENDPOINT}/themes/${theme}`;
        axios({ method: "GET", url: url }).then(
          (result) => {
            // Check if there is only one Country entry in the Theme
            // Check if the data is valid, if not, redirect to error page
            if (result.data.countries) {
              if (result.data.countries.length === 1) {
                to.params.country = `c-${result.data.countries[0].countryId}`;
              }
              next();
            } else {
              next("/error");
            }
          },
          (error) => {
            console.error(error);
          }
        );
      } else {
        next();
      }
    },
    props: { default: true },
  },
  {
    path: "/countries/:country/:filter?/:territory?/:location?/:route?/:monument?/:language?/:tab?",
    name: "countries",
    components: {
      default: ExplorePage,
    },
    beforeEnter: (to, from, next) => {
      assignParams(to);
      next();
    },
    props: { default: true },
  },
  {
    path: "/itineraries/:country/:territory?/:itinerary?/:subItinerary?/:monument?/:language?/:tab?",
    name: "itineraries",
    components: {
      default: ExplorePage,
    },
    beforeEnter: (to, from, next) => {
      assignParams(to, "itinerary");
      next();
    },
    props: { default: true },
  },
  {
    path: "/error",
    name: "error",
    components: {
      default: ErrorPage,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/error"
  }
];

// export default new Router({
//   mode: "history",
//   base: process.env.BASE_URL,
//   routes,
//   scrollBehavior(to, from, savedPosition) {
//     if (to.hash) {
//       setTimeout(() => {
//         const element = document.getElementById(to.hash.replace(/#/, ""));
//         if (element && element.scrollIntoView) {
//           element.scrollIntoView({ block: 'start', behavior: 'smooth' });
//         }
//       }, 3000);
//       return { el: to.hash, behavior: 'smooth', };
//     } else {
//       return window.scrollTo({ top: 0, behavior: "smooth" });
//     }
//   },
// });

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      setTimeout(() => {
        const element = document.getElementById(to.hash.replace(/#/, ""));
        if (element && element.scrollIntoView) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }, 3000);
      return { el: to.hash, behavior: 'smooth', };
    } else {
      return window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
});

// const updateMeta = () => {
//   const { meta } = router.currentRoute.value;
//   const componentMeta = router.currentRoute.value.matched.find((route) => route.components.default)?.components.default.metaInfo();
//   useHead({
//     title: meta?.title || componentMeta?.title || "MWNF Explore",
//     meta: [
//       { name: 'description', content: meta?.description || componentMeta?.meta?.[0]?.content || ""},
//     ],
//   });
// };

const updateMeta = () => {
  const { meta } = router.currentRoute.value;
  const componentMeta = router.currentRoute.value.matched.find((route) => route.components.default)?.components.default;
 
  // Only proceed if componentMeta exists and has a metaInfo property
  if (componentMeta && typeof componentMeta.metaInfo === 'function') {
    const metaFromComponent = componentMeta.metaInfo();
 
    useHead({
      title: meta?.title || metaFromComponent?.title || "MWNF Explore",
      meta: [
        { name: 'description', content: meta?.description || metaFromComponent?.meta?.[0]?.content || ""},
      ],
    });
  }
 };

router.beforeEach((to, from) => {
  updateMeta();
});

export default router;